<div class="row">
    <div class="col-md-6">
        <h3>Kategorier:</h3>
        <table class="table table-striped">
            <tbody>
                <tr *ngFor="let cat of categories">
                    <td>{{cat['name']}}</td>
                    <td>
                        <div class="btn-group float-right">
                            <button type="button" class="btn btn-info btn-sm" (click)="editCategory(+cat['id'], cat['name'])">Omdøb</button>
                            <button type="button" class="btn btn-warning btn-sm" *ngIf="+cat['id'] != 1" (click)="removeCategory(+cat['id'])">Slet</button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <div>
            <div class="float-right">
                <button class="btn btn-success" (click)="addCategory()">Opret kategori</button>
            </div>
        </div>
    </div>
    <div class="col-md-6">
        <h3>Brugere:</h3>
        <table class="table table-striped">
            <tbody>
                <tr *ngFor="let user of users">
                    <td>{{user['username']}}</td>
                    <td>
                        <mat-checkbox *ngIf="user['username'].toLowerCase() != 'supervisor'" [checked]="+user['verified'] == 1"
                                        (change)="setVerified(+user['id'], $event.checked)">
                            Verificeret
                        </mat-checkbox>
                    </td>
                    <td>
                        <div class="btn-group float-right">
                            <button type="button" class="btn btn-info btn-sm" (click)="editUser(user)">Rediger</button>
                            <button *ngIf="user['username'].toLowerCase() != 'supervisor'" type="button" class="btn btn-warning btn-sm" (click)="removeUser(user['id'])">Slet</button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="row">
    <div class="col-md-6">
        <h3>Konfiguration:</h3>
        <table class="table">
            <tbody>
                <tr>
                    <th>Tekst til 'Home'-knappen</th>
                    <td>
                        <button class="btn btn-primary float-right" (click)="editHomeLinkText()">Rediger</button>
                    </td>
                </tr>
                <tr>
                    <th>Link til 'Home'-knappen</th>
                    <td>
                        <button class="btn btn-primary float-right" (click)="editHomeLinkHref()">Rediger</button>
                    </td>
                </tr>
                <tr>
                    <th>Rod URL til webapplikationen (bruges til mail)</th>
                    <td>
                        <button class="btn btn-primary float-right" (click)="editMailRootURL()">Rediger</button>
                    </td>
                </tr>
                <tr>
                    <th>Standardtekst til mail om nylig godkendelse</th>
                    <td>
                        <button class="btn btn-primary float-right" (click)="editMailAcceptedText()">Rediger</button>
                    </td>
                </tr>
                <tr>
                    <th>Standardtekst til mail om afvisning</th>
                    <td>
                        <button class="btn btn-primary float-right" (click)="editMailRejectedText()">Rediger</button>
                    </td>
                </tr>
                <tr>
                    <th>Vejledende tekst på velkomstsiden.</th>
                    <td>
                        <button class="btn btn-primary float-right" (click)="editWelcomeGuide()">Rediger</button>
                    </td>
                </tr>
                <tr>
                    <th>Vejledende tekst til tilføjelse/redigering af udstyr.</th>
                    <td>
                        <button class="btn btn-primary float-right" (click)="editGearAddEditGuide()">Rediger</button>
                    </td>
                </tr>
                <tr>
                    <th>Iframe mode</th>
                    <td>
                        <mat-checkbox class="float-right" [checked]="iframeMode"
                                        (change)="setIframeMode($event.checked)"></mat-checkbox>
                    </td>
                </tr>
                <tr>
                    <th>Systemtype</th>
                    <td>
                        <div class="form-group float-right">
                            <select class="form-control form-control-sm" [(ngModel)]="systemType" (change)="updateSystemType()">
                                <option value="udlaan">Udlån</option>
                                <option value="foraering">Foræring</option>
                            </select>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="col-md-6">
        <h3>Yderligere funktioner:</h3>
        <div class="adminDataLink">
            <a class="btn btn-sm btn-primary" href="assets/admin/get_backup.php?t=users">Hent bruger-data som CSV</a>
        </div>
        <div class="adminDataLink">
            <a class="btn btn-sm btn-primary" href="assets/admin/get_backup.php?t=gear">Hent gear-data som CSV</a>
        </div>
        <div class="adminDataLink">
            <a class="btn btn-sm btn-primary" href="assets/admin/get_backup.php?t=reservations">Hent reservations-data som CSV</a>
        </div>
        <div class="adminDataLink">
            <button class="btn btn-sm btn-danger" (click)="deleteOldReservations()">Slet udløbne reservationer</button>

        </div>
    </div>
</div>